import { css } from '@emotion/react';

export function dashboardStyles() {
    return css`



        /* Estilos para el contenedor principal del dashboard */
        .dashboard-main-content {
            flex: 1 !important;
            min-width: 0 !important;
            width: 100% !important;
        }

        .render-content{
            .p-card{
                border-radius: 17px !important;
                    border: 1px solid #e0e0e0 !important;
            }
            
        }

    
        /* Estilos globales del dashboard */
        .dashboard-container {
            background: var(--surface-50);
        }

         .dashboard-content{
         padding: 0.5rem !important;
         
         }

        .dashboard-content > .p-card {
            border-radius: 17px !important;
            width: 100% !important;
            box-shadow: none !important;
            background: var(--surface-0) !important;
            margin-bottom: 1rem !important;
            border-radius: 17px !important;
            border: 1px solid #e0e0e0 !important;
        }

        /* Estilos del sidebar */
        .surface-section {
            height: calc(100vh - 3rem);
            border-radius: 17px !important;
            border: 1px solid #e0e0e0 !important;
        }

        /* Estilos para evitar saltos de línea en categorías */
        .categoria-nombre {
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            max-width: 100% !important;
        }

        .sidebar-item {
            display: flex !important;
            align-items: center !important;
            width: 100% !important;
            min-width: 0 !important;
        }

        /* Estilos para el icono de colapso */
        .collapse-icon {
            cursor: pointer !important;
            padding: 0.5rem !important;
            border-radius: 50% !important;
            transition: all 0.2s ease !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
        }

        .collapse-icon:hover {
            background-color: var(--surface-100) !important;
            transform: scale(1.1) !important;
        }

        .collapse-icon:active {
            transform: scale(0.95) !important;
        }

        /* Animaciones de fade para los textos */
        .sidebar-text {
            transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out !important;
            display: inline-block !important;
        }

        .sidebar-text.fade-in {
            opacity: 1 !important;
            transform: translateX(0) !important;
        }

        .sidebar-text.fade-out {
            opacity: 0 !important;
            transform: translateX(-10px) !important;
        }

        /* Animación para el título */
        .sidebar-title-text {
            transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out !important;
            display: inline-block !important;
        }

        .sidebar-title-text.fade-in {
            opacity: 1 !important;
            transform: translateX(0) !important;
        }

        .sidebar-title-text.fade-out {
            opacity: 0 !important;
            transform: translateX(-10px) !important;
        }

        /* Animación específica para tags */
        .sidebar-tag {
            transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out !important;
        }

        .sidebar-tag.fade-in {
            opacity: 1 !important;
            transform: scale(1) !important;
        }

        .sidebar-tag.fade-out {
            opacity: 0 !important;
            transform: scale(0.8) !important;
        }

        .transition-all {
            transition: all 0.3s ease-in-out;
        }

        .sidebar-collapse-button {
            transition: transform 0.3s ease;
        }

        .sidebar-collapse-button:hover {
            transform: scale(1.1);
        }

        .sidebar-collapse-button:active {
            transform: scale(0.9);
        }

        /* Estilos del botón personalizado */
        .Button {
            position: relative;
            cursor: pointer;
            border-radius: 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            padding: 1rem 0;

            flex-basis: 0;
            flex-grow: 1;

            border: none !important;
            outline: none !important;
            box-shadow: none !important;

            /* keep button label close to icon/text */
            .p-button-label {
                flex: 0 0 auto !important;
                margin: 0 !important;
                margin-left: 0.5rem !important;
            }
        }

        .Button:focus {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .Button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .Button:active {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .Button:hover {
            border: none !important;
        }

        /* Estilos específicos para PrimeReact */
        .p-button {
            border: none !important;
        }

        .p-button:focus {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .p-button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .p-button:active {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        .p-button:hover {
            border: none !important;
        }

        .p-button.p-button-text:focus {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
        }

        /* Colores del botón */
        .Green {
            background-color: #22ec9a !important;
            color: white !important;
            border: none !important;
            &:hover {
                background-color: #22ec9a !important;
                color: white !important;
            }
        }

        .Button {
            border-radius: 17px !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            &:hover {
                border: none !important;
            }
            
        }

        .Blue {
            background-color: #32b8df !important;
            color: white !important;
            &:hover {
                background-color: #2da5c8 !important;
                color: white !important;
            }
        }

        /* Estilos adicionales del dashboard */
        .dashboard-header {
            background: var(--surface-100);
            border-radius: 12px;
            padding: 1rem;
            margin-bottom: 1rem;
        }

        .dashboard-content {
            background: var(--surface-0);
            border-radius: 12px;
            padding: 1.5rem;
        }

        .dashboard-sidebar {
            background: var(--surface-50);
            border-radius: 17px;
            border: 1px solid var(--surface-border);
        }

        /* Sidebar responsive */
        .sidebar-container {
            width: 100% !important;
            flex-shrink: 0 !important;
        }

        @media (min-width: 768px) {
            .sidebar-container {
                width: var(--sidebar-width, 250px) !important;
            }
        }

        
        /* ── Dashboard Header Card ── */
        .dh-card {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: var(--surface-0, #fff);
            border-radius: 14px;
            box-shadow: 0 1px 6px rgba(0,0,0,0.07);
            border: 1px solid var(--surface-border, #e5e7eb);
            padding: 0.75rem 1.25rem;
            margin-bottom: 0.75rem;
            flex-wrap: wrap;
            transition: box-shadow 0.2s;
        }

        /* ── Title Section ── */
        .dh-title-section {
            display: flex;
            align-items: center;
            gap: 0.6rem;
            min-width: fit-content;
        }
        .dh-back-btn.p-button {
            width: 2rem !important;
            height: 2rem !important;
            color: var(--text-color-secondary, #6b7280) !important;
        }
        .dh-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 10px;
            background: rgba(50, 184, 223, 0.10);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }
        .dh-icon-box i {
            font-size: 1.1rem;
            color: #32b8df;
        }
        .dh-title-text {
            display: flex;
            flex-direction: column;
        }
        .dh-title {
            margin: 0;
            font-size: 1.05rem;
            font-weight: 700;
            color: var(--text-color, #1e293b);
            letter-spacing: -0.02em;
            line-height: 1.3;
        }
        .dh-title-sep {
            color: var(--text-color-secondary, #94a3b8);
            font-weight: 400;
            margin: 0 2px;
        }
        .dh-subtitle {
            margin: 0;
            font-size: 0.72rem;
            color: var(--text-color-secondary, #94a3b8);
            font-weight: 500;
        }

        /* ── Steps Navigation ── */
        .dh-steps-nav {
            flex: 1;
            display: flex;
            justify-content: center;
            overflow-x: auto;
            min-width: 0;
        }
        .dh-steps-list {
            display: flex;
            align-items: center;
            list-style: none;
            margin: 0;
            padding: 0;
            gap: 4px;
        }
        .dh-step-item {
            display: flex;
            align-items: center;
            position: relative;
        }
        /* Circle button */
        .dh-step-circle {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border: 2px solid var(--surface-border, #d1d5db);
            background: transparent;
            color: var(--text-color-secondary, #9ca3af);
            transition: all 0.25s ease;
            outline: none;
            flex-shrink: 0;
        }
        .dh-step-circle i {
            font-size: 0.85rem;
        }
        .dh-step-num {
            font-size: 0.78rem;
            font-weight: 700;
        }
        .dh-step-circle:disabled {
            opacity: 0.45;
            cursor: not-allowed;
        }
        .dh-step-circle:not(:disabled):hover {
            border-color: #32b8df;
            color: #32b8df;
            transform: scale(1.08);
        }
        /* Step states */
        .dh-step-circle.completed {
            background: #32b8df;
            border-color: #32b8df;
            color: white;
            box-shadow: 0 0 0 4px rgba(50, 184, 223, 0.12);
        }
        .dh-step-circle.current {
            border-color: #32b8df;
            background: var(--surface-0, #fff);
            color: #32b8df;
        }
        .dh-step-circle.pending {
            border-color: var(--surface-border, #d1d5db);
            background: transparent;
            color: var(--text-color-secondary, #9ca3af);
        }
        /* Error: paso con problema (insurance cancelado, step unsuccessful) */
        .dh-step-circle.error {
            border-color: #dc2626;
            background: rgba(220, 38, 38, 0.08);
            color: #dc2626;
            box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.10);
            position: relative;
        }
        /* Warning: paso pausado/aplazado/programado */
        .dh-step-circle.warning {
            border-color: #f59e0b;
            background: rgba(245, 158, 11, 0.08);
            color: #f59e0b;
            box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.10);
            position: relative;
        }
        /* Overlay icon (badge pequeño en esquina inferior derecha del chip) */
        .dh-step-overlay {
            position: absolute;
            bottom: -3px;
            right: -3px;
            font-size: 0.55rem !important;
            background: white;
            border-radius: 50%;
            padding: 2px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
        }
        /* Label (inline, to the right) */
        .dh-step-label {
            margin-left: 8px;
            font-size: 0.82rem;
            font-weight: 600;
            white-space: nowrap;
            color: var(--text-color-secondary, #9ca3af);
        }
        .dh-step-label.completed {
            color: #0e7490;
        }
        .dh-step-label.current {
            color: var(--text-color, #0f172a);
            font-weight: 700;
        }
        .dh-step-label.error {
            color: #dc2626;
            font-weight: 700;
        }
        .dh-step-label.warning {
            color: #b45309;
            font-weight: 700;
        }
        /* Chevron SVG separator */
        .dh-step-chevron-svg {
            width: 18px;
            height: 18px;
            color: var(--surface-border, #cbd5e1);
            margin: 0 4px;
            flex-shrink: 0;
        }

        /* ── User Section ── */
        .dh-user-section {
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: fit-content;
            padding-left: 1rem;
            border-left: 1px solid var(--surface-border, #e5e7eb);
            position: relative;
        }
        .dh-user-label {
            font-size: 0.68rem;
            color: var(--text-color-secondary, #94a3b8);
            font-weight: 500;
        }

        /* Avatar */
        .dh-avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: linear-gradient(135deg, #3b82f6, #32b8df);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 700;
            font-size: 0.8rem;
            flex-shrink: 0;
            box-shadow: 0 1px 3px rgba(0,0,0,0.12);
            letter-spacing: 0.5px;
        }
        .dh-avatar.sm {
            width: 34px;
            height: 34px;
            font-size: 0.72rem;
        }

        /* Trigger button */
        .dh-user-trigger {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 4px 10px 4px 4px;
            border-radius: 24px;
            border: 1px solid var(--surface-border, #e0e0e0);
            background: var(--surface-50, #f8fafc);
            cursor: pointer;
            transition: all 0.2s;
            outline: none;
        }
        .dh-user-trigger:hover {
            background: var(--surface-100, #f1f5f9);
            border-color: #c0c8d0;
        }
        .dh-user-trigger-text {
            display: flex;
            align-items: baseline;
            gap: 4px;
        }
        .dh-user-trigger-name {
            font-size: 0.82rem;
            font-weight: 600;
            color: var(--text-color, #1e293b);
        }
        .dh-user-trigger-type {
            font-size: 0.72rem;
            color: var(--text-color-secondary, #94a3b8);
        }
        .dh-user-chevron {
            font-size: 0.65rem;
            color: var(--text-color-secondary, #9ca3af);
            transition: transform 0.2s;
        }
        .dh-user-chevron.open {
            transform: rotate(180deg);
        }

        /* ── Switcher Backdrop ── */
        .dh-switcher-backdrop {
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.15);
            backdrop-filter: blur(2px);
            z-index: 999;
        }

        /* ── Switcher Panel ── */
        .dh-switcher-panel {
            position: absolute;
            top: calc(100% + 8px);
            right: 0;
            width: 340px;
            max-height: calc(100vh - 120px);
            background: var(--surface-0, #fff);
            border-radius: 14px;
            box-shadow: 0 8px 32px rgba(0,0,0,0.14), 0 2px 8px rgba(0,0,0,0.06);
            border: 1px solid var(--surface-border, #e2e8f0);
            display: flex;
            flex-direction: column;
            overflow: hidden;
            z-index: 1000;
        }

        /* Panel Header */
        .dh-switcher-header {
            padding: 14px 16px;
            border-bottom: 1px solid var(--surface-border, #f1f5f9);
        }
        .dh-switcher-title {
            margin: 0;
            font-size: 1rem;
            font-weight: 700;
            color: var(--text-color, #0f172a);
        }

        /* Search */
        .dh-switcher-search-wrap {
            padding: 10px 14px;
            background: var(--surface-50, #f8fafc);
        }
        .dh-switcher-search-box {
            display: flex;
            align-items: center;
            gap: 0;
            background: var(--surface-0, #fff);
            border: 1px solid var(--surface-border, #e2e8f0);
            border-radius: 10px;
            padding: 0 10px;
            transition: border-color 0.2s, box-shadow 0.2s;
            flex: 1;
            min-width: 0;
        }
        .dh-switcher-search-box:focus-within {
            border-color: #32b8df;
            box-shadow: 0 0 0 2px rgba(50, 184, 223, 0.15);
        }
        .dh-switcher-search-icon {
            font-size: 0.85rem;
            color: var(--text-color-secondary, #94a3b8);
            flex-shrink: 0;
        }
        .dh-switcher-search-input {
            flex: 1;
            border: none;
            outline: none;
            background: transparent;
            padding: 8px 8px;
            font-size: 0.85rem;
            color: var(--text-color, #0f172a);
        }
        .dh-switcher-search-input::placeholder {
            color: var(--text-color-secondary, #94a3b8);
        }
        .dh-switcher-search-clear {
            background: none;
            border: none;
            cursor: pointer;
            color: var(--text-color-secondary, #94a3b8);
            padding: 2px;
            font-size: 0.75rem;
            display: flex;
            align-items: center;
        }
        .dh-switcher-search-clear:hover {
            color: #32b8df;
        }

        /* Switcher toolbar (search + filters) */
        .dh-switcher-toolbar {
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .dh-switcher-filters {
            display: flex;
            gap: 4px;
            flex-shrink: 0;
        }
        .dh-switcher-filter-btn {
            padding: 5px 8px;
            border-radius: 16px;
            border: 1px solid var(--surface-border, #e2e8f0);
            background: var(--surface-0, #fff);
            color: var(--text-color-secondary, #64748b);
            font-size: 0.72rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.15s;
            white-space: nowrap;
        }
        .dh-switcher-filter-btn:hover {
            background: var(--surface-50, #f8fafc);
        }
        .dh-switcher-filter-btn.active {
            background: #32b8df;
            color: #fff;
            border-color: #32b8df;
        }

        /* User list */
        .dh-switcher-list {
            flex: 1;
            overflow-y: auto;
            padding: 6px;
            max-height: 320px;
        }
        .dh-switcher-divider {
            height: 1px;
            background: var(--surface-border, #f1f5f9);
            margin: 6px 8px;
        }
        .dh-switcher-section-label {
            margin: 0;
            padding: 4px 10px 6px;
            font-size: 0.68rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: var(--text-color-secondary, #94a3b8);
        }

        /* Item base */
        .dh-switcher-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            border-radius: 10px;
            width: 100%;
            text-align: left;
            border: none;
            outline: none;
            background: transparent;
            transition: background-color 0.15s;
        }
        .dh-switcher-item.active {
            background: rgba(50, 184, 223, 0.06);
            border: 1px solid rgba(50, 184, 223, 0.18);
        }
        .dh-switcher-item.clickable {
            cursor: pointer;
        }
        .dh-switcher-item.clickable:hover {
            background: var(--surface-50, #f8fafc);
        }
        .dh-switcher-item-text {
            display: flex;
            flex-direction: column;
            gap: 2px;
            flex: 1;
            min-width: 0;
        }
        .dh-switcher-item-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 6px;
        }
        .dh-switcher-item-name {
            font-size: 0.85rem;
            font-weight: 600;
            color: var(--text-color, #0f172a);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .dh-switcher-item.clickable:hover .dh-switcher-item-name {
            color: #32b8df;
        }
        .dh-switcher-item-sub {
            font-size: 0.72rem;
            color: var(--text-color-secondary, #94a3b8);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .dh-switcher-active-badge {
            font-size: 0.68rem;
            font-weight: 600;
            color: #32b8df;
            background: rgba(50, 184, 223, 0.1);
            padding: 1px 8px;
            border-radius: 10px;
            flex-shrink: 0;
        }
        .dh-switcher-switch-label {
            font-size: 0.72rem;
            font-weight: 500;
            color: #32b8df;
            opacity: 0;
            transition: opacity 0.15s;
            flex-shrink: 0;
        }
        .dh-switcher-item.clickable:hover .dh-switcher-switch-label {
            opacity: 1;
        }
        .dh-switcher-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
            padding: 2rem 1rem;
            color: var(--text-color-secondary, #94a3b8);
            font-size: 0.82rem;
        }
        .dh-switcher-empty i {
            font-size: 1.2rem;
            opacity: 0.5;
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
            .dh-card {
                flex-direction: column;
                align-items: stretch;
                gap: 0.75rem;
                padding: 0.75rem;
            }
            .dh-steps-nav {
                justify-content: flex-start;
                padding: 0.5rem 0;
            }
            .dh-user-section {
                border-left: none;
                border-top: 1px solid var(--surface-border, #e5e7eb);
                padding-left: 0;
                padding-top: 0.75rem;
            }
            .dh-switcher-panel {
                width: calc(100vw - 2rem);
                right: -0.75rem;
            }
        }

    `
}